import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ChatMessageModel } from '@smarttask-common/src/lib/models/Chat/Message/Core/ChatMessageModel';

export enum ChatMessageActionTypes {
    ADD_MESSAGE = '[ChatMessage] Add ChatMessage',
    ADD_MESSAGES = '[ChatMessage] Add ChatMessages',
    UPSERT_MESSAGE = '[ChatMessage] Upsert ChatMessage',
    UPSERT_MESSAGES = '[ChatMessage] Upsert ChatMessages',
    UPDATE_MESSAGE = '[ChatMessage] Update ChatMessage',
    UPDATE_MESSAGES = '[ChatMessage] Update ChatMessages',
    DELETE_MESSAGE = '[ChatMessage] Delete ChatMessage',
    DELETE_MESSAGES = '[ChatMessage] Delete ChatMessages',
    DELETE_ALL_MESSAGES = '[ChatMessage] Delete All ChatMessages',
    DELETE_ALL = '[ChatMessage] Delete All',

    UPDATE_SELECTED_ID = '[ChatMessage] Update SelectedId',
}

export class UpdateSelectedChatMessageId implements Action {
    readonly type = ChatMessageActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_message_id: string) {}
}

export class AddOne implements Action {
    readonly type = ChatMessageActionTypes.ADD_MESSAGE;
    constructor(public message: ChatMessageModel) {}
}

export class AddMany implements Action {
    readonly type = ChatMessageActionTypes.ADD_MESSAGES;
    constructor(public messages: Array<ChatMessageModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ChatMessageActionTypes.UPSERT_MESSAGE;

    constructor(public message: ChatMessageModel) {}
}

export class UpsertMany implements Action {
    readonly type = ChatMessageActionTypes.UPSERT_MESSAGES;
    constructor(public messages: Array<ChatMessageModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ChatMessageActionTypes.UPDATE_MESSAGE;
    constructor(public message: Update<ChatMessageModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ChatMessageActionTypes.UPDATE_MESSAGES;
    constructor(public messages: Array<Update<ChatMessageModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ChatMessageActionTypes.DELETE_MESSAGE;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ChatMessageActionTypes.DELETE_MESSAGES;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ChatMessageActionTypes.DELETE_ALL_MESSAGES;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ChatMessageActionTypes.DELETE_ALL;
    constructor() {}
}

export type ChatMessageActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedChatMessageId;
